<button #defaultOriginDialogButtons="voxelOverlayOrigin" voxelOverlayOrigin class="no-visible"></button>

<div class="voxel-container-md" [ngClass]="headerClass">
  <div class="portal-header-link">
    <button voxelButtonAction (click)="closeApp()">
      {{closeText}}
    </button>
    <voxel-icon type="secondary" (click)="closeApp()" class="ico">fechar</voxel-icon>
  </div>
  <h2 class="header-title">{{headerTitle}}</h2>

  <voxel-tabs #tabsComponent [tabs]="tabs" [current]="currentTab"
    (tabChange)="tabsClick($event)">
  </voxel-tabs>

</div>

<span class="header-subtitle" *ngIf="headerSubtitle">{{headerSubtitle}}</span>

<voxel-dialog [dialogOrigin]="defaultOriginDialogButtons" [id]="'dialog-a'" [dialogIsOpen]="dialogShow">
  <p>Si deseas salir de la solicitud actual, se perderá la información ingresada previamente.</p>
  <p>¿Deseas continuar?</p>

  <div voxelDialogFooter>
    <button voxelButtonContextual (click)="confirmClose(ACTIONS_DIALOG.CANCEL)">
      Cancelar
    </button>
    <button voxelButtonContextual (click)="confirmClose(ACTIONS_DIALOG.CONFIRM)">
      Aceptar
    </button>
  </div>

</voxel-dialog>

<voxel-dialog [dialogOrigin]="defaultOriginDialogButtons" [id]="'dialog-b'" [dialogIsOpen]="dialogChangeShow">
  <p>Si deseas salir de la solicitud actual, se perderá la información ingresada previamente.</p>
  <p>¿Deseas continuar?</p>

  <div voxelDialogFooter>
    <button voxelButtonContextual (click)="confirmNavigate(ACTIONS_DIALOG.CANCEL)">
      Cancelar
    </button>
    <button voxelButtonContextual (click)="confirmNavigate(ACTIONS_DIALOG.CONFIRM)">
      Aceptar
    </button>
  </div>

</voxel-dialog>